import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartLine32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconChartLine32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.132 20.504a1 1 0 0 0 1.736.992l3.27-5.722 3.081 3.85a1 1 0 0 0 1.737-.33L20.17 8.846l2.915 6.56a1 1 0 1 0 1.828-.812l-4-9a1 1 0 0 0-1.87.112L15.6 16.899l-2.82-3.524a1 1 0 0 0-1.648.129zM5 24a1 1 0 1 0 0 2h22a1 1 0 0 0 0-2z"
            />
        </svg>
    );
}
export default memo(IconChartLine32);
